import React from 'react';
import { useDentoData } from '../context/DentoContext';
import { SpiralAnimation } from './ui/SpiralAnimation';

export const Hero = ({ onAppointmentClick }) => {
    const { hospitalData } = useDentoData();

    return (
        <section id="home" className="relative min-h-[85vh] flex items-center justify-center overflow-hidden bg-white">
            {/* Spiral Animation Background */}
            <div className="absolute inset-0 pointer-events-none">
                <SpiralAnimation />
            </div>

            {/* Content overlay */}
            <div className="container mx-auto px-4 relative z-10 text-center">
                <h1 className="text-4xl md:text-5xl lg:text-7xl font-extrabold text-black mb-6 leading-tight tracking-tight font-heading">
                    Dr. Ajinkya's Dento Care
                </h1>
                <p className="text-lg md:text-xl font-medium text-black/40 mb-4 tracking-[0.2em] uppercase font-heading">
                    {hospitalData.tagline || "AN ADVANCED DENTAL CLINIC"}
                </p>
                <p className="text-black/50 max-w-2xl mx-auto mb-10 md:mb-20 text-base md:text-lg leading-relaxed font-body">
                    A state-of-the-art dental clinic providing comprehensive oral health care services with advanced technology and compassionate care.
                </p>

                {/* Book Appointment — minimalist text link style */}
                <button
                    onClick={onAppointmentClick}
                    className="
                        text-black text-xl tracking-[0.5em] uppercase font-light
                        transition-all duration-700
                        hover:tracking-[0.7em] border-b border-black/20 pb-4 px-12
                        hover:border-black/60
                    "
                >
                    Book Appointment
                </button>
            </div>
        </section>
    );
};
